import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

import * as styles from './index.module.css'

const BasicImage = ({
  images,
  mobileOnlyImages,
  backgroundImageFillMode,
  backgroundColor = '#fff',
}) => {
  const fullWidthMode = backgroundImageFillMode === 'fullWidth'
  const sources = !mobileOnlyImages
    ? [images[0].gatsbyImageData]
    : [
        mobileOnlyImages[0].gatsbyImageData,
        {
          ...images[0].gatsbyImageData,
          media: `(min-width: 768px)`,
        },
      ]

  const alt = [images[0]?.description]

  return (
    <div
      style={{
        backgroundColor: fullWidthMode ? '' : backgroundColor,
      }}
      className={[
        styles.basicImageContainer,
        fullWidthMode ? '' : styles.constraint,
      ].join(' ')}
    >
      <GatsbyImage
        image={sources[0]}
        backgroundColor={backgroundColor}
        imgStyle={{ objectPosition: '50% 50%' }}
        alt={alt}
      />
    </div>
  )
}

export default BasicImage
